<template>
  <label class="flex w-full flex-col">
    <!-- NOTE: careful when changing this component, the error field below will be considered for element height, therefore its height needs to be kept in sync with the label height to prevent horizontal misalignment of the form component with other components -->
    <div class="font-bold">
      <slot name="label" />
    </div>
    <div
      :class="[
        'bg-white-500 flex-1 rounded-md ring-1 focus-within:ring-2',
        hasError
          ? 'ring-danger-500 bg-red-100'
          : 'focus-within:ring-primary-500 ring-neutral-300',
      ]"
    >
      <div
        class="t-input-container flex min-h-[40px] w-full items-center border-0 px-2 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm"
      >
        <div class="grow">
          <slot />
        </div>
      </div>
    </div>
    <div class="text-danger-500 mt-2 ml-5 text-xs" data-testid="form-error">
      <slot name="error">
        <!-- reserve space for error text -->
        <div class="h-4"></div>
      </slot>
    </div>
  </label>
</template>

<script lang="ts" setup>
defineProps<{
  hasError?: boolean;
}>();
</script>
<style>
.t-input-container input {
  width: 100%;
  flex: 1 1 0%;
  border-width: 0px;
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    0 0 #0000;
}

.t-input-container textarea {
  width: 100%;
  flex: 1 1 0%;
  border-width: 0px;
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    0 0 #0000;
}

.t-input-container .t-light-editor {
  width: 100%;
  flex: 1 1 0%;
  border-width: 0px;
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  box-shadow:
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    0 0 #0000;
}
</style>
